
import React from 'react';
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { UseFormReturn } from "react-hook-form";
import { CampaignSettings } from "../types";

interface AdditionalSettingsSectionProps {
  form: UseFormReturn<CampaignSettings>;
}

export const AdditionalSettingsSection: React.FC<AdditionalSettingsSectionProps> = ({
  form
}) => {
  const { watch, setValue } = form;

  return (
    <div className="space-y-4 pt-4">
      <h4 className="text-sm font-medium">Additional Settings</h4>
      <div className="space-y-4">
        <div className="flex flex-row items-start space-x-3 space-y-0">
          <Checkbox
            id="limitReferrals"
            checked={watch('limitReferrals')}
            onCheckedChange={(checked) => setValue('limitReferrals', !!checked)}
          />
          <div className="space-y-1 leading-none">
            <Label htmlFor="limitReferrals">Limit Referrer Referrals</Label>
            <p className="text-sm text-muted-foreground">
              Set a maximum number of rewarded referrals per user
            </p>
          </div>
        </div>

        <div className="flex flex-row items-start space-x-3 space-y-0">
          <Checkbox
            id="collectPhoneNumber"
            checked={watch('collectPhoneNumber')}
            onCheckedChange={(checked) => setValue('collectPhoneNumber', !!checked)}
          />
          <div className="space-y-1 leading-none">
            <Label htmlFor="collectPhoneNumber">Collect Phone Number</Label>
            <p className="text-sm text-muted-foreground">
              Request phone number from participants
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
